<template>
  <button @click="$emit('click')" class="info-button" :disabled="this.disabled">
    <InfoIcon class="info-icon" />
  </button>
</template>

<script>
import InfoIcon from "../../0_atoms/icons/InfoIcon.vue";

export default {
  name: "SmallInfoButton",
  props: {
    disabled: Boolean
  },
  components: {
    InfoIcon
  }
};
</script>

<style lang="scss" scoped>
@import "../../utils/assets/stylesheets/variables.scss";

.info-button {
  display: block;
  width: 23px;
  height: 23px;
  border-radius: 50%;
  text-align: center;
  outline: none;

  background-color: $gray-lighten-1;
  color: $primary-lighten-1;
  fill: $primary-lighten-1;

  &:hover {
    background-color: $secondary-lighten-3;
    color: $secondary;
    fill: $secondary;
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.3;
  }

  .info-icon {
    height: 12px;
    position: relative;
    top: 0px;
    left: -1px;
  }
}
</style>
